'use client'

import { ProductCarousel } from '@/components/common'
import { ProductCardSkeleton } from '@/components/common/product-card/product-item-skeleton'
import { useProductWornTogether } from '@/hooks/react-query/products/use-product'
import { cn } from '@/lib/utils'
import { useTranslations } from 'next-intl'
import { useSearchParams } from 'next/navigation'

export const ProductWornTogether = ({
  productId,
  genderType,
}: {
  productId: string
  genderType?: string
}) => {
  const t = useTranslations('product_detail.title')
  const searchParams = useSearchParams()
  const previewToken = searchParams.get('preview')
  const { data: wornTogetherProducts, isLoading } = useProductWornTogether(
    productId,
    previewToken || ''
  )

  if (isLoading) {
    return (
      <div className='m-4 grid auto-cols-[160px] grid-flow-col gap-4 overflow-x-auto md:auto-cols-fr md:grid-cols-3 lg:grid-cols-4'>
        {[...Array(4)].map((_, i) => (
          <ProductCardSkeleton key={i} />
        ))}
      </div>
    )
  }

  if (!wornTogetherProducts || !wornTogetherProducts.length) {
    return null
  }

  return (
    <section
      className={cn(
        'bg-light px-5 py-8 lg:p-15',
        genderType === 'FEMALE' && 'lg:pt-0'
      )}
      aria-label={t('worn_together')}
      data-tracking-level-2={`Matchinglook_${genderType}`}
    >
      <h2 className='mb-3 font-criteria text-lg font-medium uppercase leading-6.5 text-neutral-900 lg:mb-4 lg:text-[28px] lg:leading-10'>
        {t('worn_together')}
      </h2>
      <ProductCarousel
        products={wornTogetherProducts}
        gaTrackingValue='product-detail__worn-together'
        gaTrackingLabel='product-detail__worn-together'
      />
    </section>
  )
}

